module.exports = __webpack_public_path__ + "static/media/jia2022hierarchical.232dd424.avif";